import { TOUR_IDS } from "@demandproai/shared";
import RenderIf from "../render-if/Renderif";
import useDemandStudioTour from "../../hooks/useDemandStudioTour";
import useTourRefresher from "../../hooks/useTourRefresher";
import TourRefresherPrompt from "./TourRefresherPrompt";

const DemandStudioTourRunner = () => {
   const { Tour } = useDemandStudioTour();
   const { isOffering, acceptRefresher, declineRefresher } = useTourRefresher({
      tourId: TOUR_IDS.DEMAND_STUDIO,
   });

   return (
      <>
         {Tour}

         <RenderIf shouldRender={isOffering}>
            <TourRefresherPrompt onAccept={acceptRefresher} onDecline={declineRefresher} />
         </RenderIf>
      </>
   );
};

export default DemandStudioTourRunner;
